import {
    Text,
    Page,
    StyleSheet,
    Image,
    View,
    Font
} from "@react-pdf/renderer";
import frameAso from "./images/frame_asociart.png";
import { WEBURLEGALES } from "../../../../helpers/frontend.js"
import HelveticaBold from "../../../../../assets/fonts/Helvetica-Bold.ttf";
import OpenSansBold from "../../../../../assets/fonts/OpenSans-Bold.ttf";
import { convertirNumero, numeroEnPalabras, obtenerMesYAnio } from "../../../../helpers/funciones.js";

Font.register({
    family: "Helvetica-Bold",  // Nombre que usarás en los estilos
    src: HelveticaBold,        // Ruta a la fuente
});

Font.register({
    family: "OpenSans",
    fonts: [
        { src: OpenSansBold, fontWeight: "bold" }, // Asegura que tenga el peso correcto
    ],
});

const styles = StyleSheet.create({
    page: {
        paddingTop: 10,
        paddingRight: 10,
        paddingLeft: 10,
        paddingBottom: 40
    },
    title: {
        fontSize: 12,
        fontWeight: 'bold',
        textAlign: "right",
        color: "black",
        backgroundImage: `url("${WEBURLEGALES}/images/frame_asociart.png")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        marginTop: 20,
        marginRight: 20,
        height: 50,
    },
    section: {
        display: "flex",
        flexDirection: "row",
    },
    parragraph10: {
        fontSize: 10,
        textAlign: "left",
    },
    parragraphSub10: {
        fontSize: 10,
        textAlign: "right",
    },
    parragraph: {
        fontSize: 10,
        textAlign: "left",
        lineHeight: 1.5,
        margin: 10,
    },
    tableHeader: {
        width: "100%",
        borderCollapse: "collapse",
        marginTop: 10,
    },
    table: {
        width: "100%",
        borderCollapse: "collapse",
    },
    row: {
        display: "flex",
        flexDirection: "row",
    },
    row1: {
        display: "flex",
        flexDirection: "row",
        borderBottom: "4px solid #EB0045",
    },
    row2: {
        display: "flex",
        flexDirection: "row",
        borderBottom: "2px solid black",
    },
    cell: {
        flex: 1,
        padding: 8,
        fontSize: 10,
        borderLeft: "none",
    },
    cell1: {
        flex: 1,
        padding: 8,
        fontWeight: "900",
        fontSize: 10,
        backgroundColor: "#E4E4E4",
        border: "1px solid gray",
    },
    cell2: {
        flex: 1,
        padding: 8,
        fontSize: 10,
        borderTop: "4px solid #EB0045",
    },
    cell3: {
        flex: 1,
        padding: 8,
        fontSize: 12,
        borderLeft: "1px solid gray",
        borderRight: "1px solid gray",
        borderBottom: "1px solid gray",
    },
    cell4: {
        flex: 1,
        padding: 8,
        fontSize: 10,
        backgroundColor: "#E4E4E4",
        border: "1px solid gray",
    },
    cellBold: {
        flex: 1,
        padding: 8,
        fontSize: 10,
        borderLeft: "none",
        fontFamily: "Helvetica",
        fontWeight: "bold"
    },
    pageBackground: {
        position: "absolute",
        minWidth: "100%",
        minHeight: "100%",
        display: "block",
        height: "700px",
        width: "100%",
    },
    tableDetalle: {
        display: "table",
        width: "100%",
        borderStyle: "solid",
        borderWidth: 1,
        borderColor: "#000",
    },
    rowDetalle: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderBottomColor: "#000",
        borderBottomStyle: "solid",
    },
    headerCellDetalle: {
        flex: 1,
        padding: 8,
        fontSize: 9,
        textAlign: "center",
        borderRightWidth: 1,
        borderRightColor: "#000",
        borderRightStyle: "solid",
        fontWeight: "bold", // Negrita para títulos
        backgroundColor: "#ddd",
    },
    cellDetalle: {
        flex: 1,
        padding: 8,
        fontSize: 9,
        textAlign: "center",
        borderRightWidth: 1,
        borderRightColor: "#000",
        borderRightStyle: "solid",
    },
    lastCellDetalle: {
        flex: 1,
        padding: 8,
        fontSize: 9,
        textAlign: "center",
    },
    mergedRowDetalle: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderBottomColor: "#000",
        borderBottomStyle: "solid",
        backgroundColor: "#f2f2f2",
    },
    lastRowDetalle: {
        flexDirection: "row",
        padding: 8,
        borderTopWidth: 1,
        borderTopColor: "#000",
        borderTopStyle: "solid",
        backgroundColor: "#f2f2f2",
    },
    leftTextDetalle: {
        flex: 1,
        fontSize: 9,
        textAlign: "left",
        fontWeight: "bold",
    },
    rightTextDetalle: {
        flex: 1,
        fontSize: 9,
        textAlign: "right",
        fontFamily: "Helvetica-Bold",
        fontWeight: "bold",
    },

});


function CertificadoRetencionIIBB({ datosImpresion }) {

    const operacionesConIIBB = datosImpresion.some(op => op.tipoRetencion === '$B');

    const operacionesConGcia = datosImpresion.some(op => op.tipoRetencion === '$G');

    const totalRetencion = datosImpresion.filter((op) => op.tipoRetencion === '$B').reduce((acc, op) => {
        const montoStr = op.montoPorLinea?.toString() || "0"; // Convertimos a string o "0" si es undefined
        const importeNumero = parseFloat(montoStr.replace(/\./g, '').replace(',', '.')) || 0;
        return acc + importeNumero;
    }, 0);

    const totalOperacionesIIBB = datosImpresion.filter((op) => op.tipoRetencion !== '$B' && op.tipoRetencion !== '$G').reduce((acc, op) => {
        const montoStr = op.montoPorLinea?.toString() || "0"; // Convertimos a string o "0" si es undefined
        const importeNumero = parseFloat(montoStr.replace(/\./g, '').replace(',', '.')) || 0;
        return acc + importeNumero;
    }, 0).toLocaleString('es-AR', { minimumFractionDigits: 2 });

    const totalOperacionesIIBB_Gcia = datosImpresion.filter((op) => op.tipoRetencion !== '$B' && op.tipoRetencion !== '$G').reduce((acc, op) => {
        const montoStr = op.montoPorLineaRetencion?.toString() || "0"; // Convertimos a string o "0" si es undefined
        const importeNumero = parseFloat(montoStr.replace(/\./g, '').replace(',', '.')) || 0;
        return acc + importeNumero;
    }, 0).toLocaleString('es-AR', { minimumFractionDigits: 2 });

    //Obtengo la Alicuota de IIBB
    const sumaMontoPorLinea = convertirNumero(datosImpresion
        .filter((op) => op.tipoRetencion === '$B')
        .reduce((sum, op) => sum + (op.montoPorLinea || 0), 0))

    const totalOperaciones = operacionesConIIBB && operacionesConGcia
        ? convertirNumero(totalOperacionesIIBB_Gcia)
        : convertirNumero(totalOperacionesIIBB);

    // Verifica que totalOperaciones no sea 0 o NaN antes de dividir
    const alicuotaIIBB = totalOperaciones && !isNaN(totalOperaciones)
        ? parseFloat(((sumaMontoPorLinea / totalOperaciones) * 100).toFixed(2))
        : 0; // Retorna 0 si no es posible calcular

    // Componente de tabla
    const TablaOperaciones = () => (
        <View style={styles.tableDetalle}>
            {/* Encabezado */}
            <View style={[styles.rowDetalle, { backgroundColor: "#ddd" }]}>
                {["Fecha Comprobante", "Numero de Factura" ].map((col, i) => (
                    <Text key={i} style={styles.headerCellDetalle}>{col}</Text>
                ))}
            </View>

            {/* Filas */}
            {datosImpresion
                .filter((op) => op.tipoRetencion !== '$B' && op.tipoRetencion !== '$G')
                .map((op) => (
                    <View key={op.Id} style={styles.rowDetalle}>
                        <Text style={styles.cellDetalle}>{op.fechaComprobante}</Text>
                        <Text style={styles.cellDetalle}>{op.nroFactura}</Text>
                    </View>
                ))}
        </View>
    );

    // Componente de tabla
    const TablaRetencion = () => (
        <View style={styles.tableDetalle}>
            {/* Encabezado */}
            <View style={[styles.rowDetalle, { backgroundColor: "#ddd" }]}>
                {["Importe Retención"].map((col, i) => (
                    <Text key={i} style={styles.headerCellDetalle}>{col}</Text>
                ))}
            </View>

            {/* Filas */}
            {datosImpresion
                .filter((op) => op.tipoRetencion === '$B')
                .map((op) => (
                    <View key={op.Id} style={styles.rowDetalle}>
                        <Text style={styles.cellDetalle}>{op.montoPorLinea}</Text>
                    </View>
                ))}
        </View>
    );

    return (
        <Page style={styles.page}>
            <View style={styles.pageBackground}>
                <Image src={frameAso} />
            </View>
            <Text style={[styles.title, { fontFamily: "Helvetica-Bold" }]}>
                {"CERTIFICADO DE RETENCIÓN DE INGRESOS BRUTOS"}
            </Text>
            <View style={styles.table}>
                <View style={[styles.row]}>
                    <Text style={[styles.cell, { flex: 2 }]}>
                        {"Capital Federal"}
                    </Text>
                </View>
            </View>
            <View style={styles.table}>
                <View style={[styles.row1]}>
                    <Text style={[styles.cell, { flex: 2 }]}>
                        {"Fecha: "}{datosImpresion[0].fechaPago}
                    </Text>
                    <Text style={[styles.cell, { flex: 1 }]}>
                        {"Orden de Pago: "}{String(datosImpresion[0].nroOrden)}</Text>
                </View>
            </View>
            <View style={styles.table}>
                <View style={[styles.row, { paddingLeft: 8 }]}>
                    <Text style={[styles.cellBold]}>
                        {"Datos del Agente de Retención"}</Text>
                </View>
            </View>
            <View style={styles.table}>
                <View style={[styles.row1, { paddingLeft: 8 }]}>
                    <Text style={[styles.cell, { flex: 2 }]}>
                        {"ASOCIART S.A. A.R.T."}
                    </Text>
                    <Text style={[styles.cell, { flex: 1 }]}>
                        {"C.U.I.T.: 30-68627333-0"}
                    </Text>
                </View>
            </View>
            <View style={styles.table}>
                <View style={[styles.row, { paddingLeft: 8 }]}>
                    <Text style={[styles.cellBold]}>
                        {"Datos del Sujeto Retenido"}</Text>
                </View>
            </View>
            <View style={styles.table}>
                <View style={[styles.row1, { paddingLeft: 8 }]}>
                    <Text style={[styles.cell, { flex: 2 }]}>
                        {datosImpresion[0].sujetoRetenido}
                    </Text>
                    <Text style={[styles.cell, { flex: 1 }]}>
                        {"C.U.I.T.: "}{datosImpresion[0].cuit}
                    </Text>
                </View>
            </View>
            <View style={styles.table}>
                <View style={[styles.row, { paddingLeft: 8 }]}>
                    <Text style={[styles.cellBold]}>
                        {"Datos de la Retención Practicada"}</Text>
                </View>
            </View>
            <TablaRetencion />
            <View style={styles.table}>
                <View style={[styles.row, { paddingLeft: 8 }]}>
                    <Text style={[styles.cell, { flex: 2 }]}>
                        {"Son Pesos: "}{numeroEnPalabras(totalRetencion)}{" -"}
                    </Text>
                </View>
            </View>
            <View style={styles.table}>
                <View style={[styles.row, { paddingLeft: 8 }]}>
                    <Text style={[styles.cellBold]}>
                        {"COMPROBANTES QUE ORIGINAN LA RETENCIÓN"}</Text>
                </View>
            </View>
            <TablaOperaciones />
            <View style={styles.table}>
                <View style={[styles.row, { paddingLeft: 8 }]}>
                    <Text style={[styles.cellBold]}>
                        {"A informarse en la DDJJ en el periodo de "}{obtenerMesYAnio(datosImpresion[0].fechaPago)}</Text>
                </View>
            </View>
            <View style={styles.table}>
                <View style={[styles.row, { paddingLeft: 8 }]}>
                    <Text style={[styles.cellBold]}>
                        {"Expendida en Capital Federal, "}{datosImpresion[0].fechaPago}</Text>
                </View>
            </View>
        </Page>
    )
}

export default CertificadoRetencionIIBB

